import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

import Button from '../../../../common/button/Button';

import './registration-success.scss';

const RegistrationSuccess = ({ navigateToLogin }) => {
  const [mobile, setMobile] = useState(false);
  const { innerWidth: width, innerHeight: height } = window;
  useEffect(() => {
    if (height < 720 || width < 554) {
      setMobile(true);
    }
  }, [width, height]);

  return (
    <div className="registration-success">
      <div className="registration-success__body">
        <p>Registration Successful</p>
        {mobile && <p>Please login on ATP (Mobile not yet supported)</p>}
        {!mobile && <Button onClick={() => navigateToLogin()}>Return to Login page</Button>}
      </div>
    </div>
  );
};

RegistrationSuccess.propTypes = {
  navigateToLogin: PropTypes.func.isRequired,
};

export default RegistrationSuccess;
